import { Navigate, Outlet, useLocation } from "react-router-dom"

import { useSessionStore } from "@/stores/sessionStore"

/**
 * Guarda de rota. UX apenas — a autorização real ocorre no backend.
 * Usuários não autenticados são redirecionados ao login (via KeycloakGate).
 */
export function AuthGuard() {
  const authenticated = useSessionStore((s) => s.authenticated)
  const tipo = useSessionStore((s) => s.tipo)
  const location = useLocation()

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  // Cidadão gov.br não acessa módulos internos: volta ao catálogo público.
  if (tipo === "CIDADAO") {
    return <Navigate to="/formularios-publicos" replace />
  }
  if (tipo !== "INTERNO") {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  return <Outlet />
}
